/* ── Styles ── */
export const styles = {
    card: {
      background: "#ffffff",
      border: "1px solid #e2e8f0",
      borderRadius: 12,
      padding: "1.25rem 1.5rem 0.5rem",
      fontFamily: "'Inter', system-ui, sans-serif",
      color: "#121e71",
      maxWidth: "100%",
      width: "100%",
    },
    header: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 12,
      marginBottom: "1rem",
    },
    title: {
      fontSize: 16,
      fontWeight: 600,
      color: "#121e71",
      margin: 0,
    },
    subtitle: {
      fontSize: 13,
      color: "#6d748c",
      margin: "4px 0 0",
    },
    controls: {
      display: "flex",
      gap: 8,
      flexWrap: "wrap",
    },
    chartWrap: { width: "100%" },
    axisTick: { fontSize: 12, fill: "#6d748c" },
    legendLabel: { fontSize: 13, color: "#6d748c" },
    tooltip: {
      background: "#fff",
      border: "1px solid #e2e8f0",
      borderRadius: 8,
      padding: "8px 12px",
      fontSize: 13,
      color: "#121e71",
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    },
    tooltipLabel: { fontWeight: 600, marginBottom: 4, color: "#121e71" },
    tooltipRow: { display: "flex", alignItems: "center", gap: 6, margin: "2px 0" },
    tooltipDot: (color) => ({
      width: 8, height: 8, borderRadius: "50%", background: color, display: "inline-block",
    }),
    dropWrap: { position: "relative" },
    dropBtn: {
      display: "flex",
      alignItems: "center",
      background: "#fff",
      border: "1px solid #e2e8f0",
      borderRadius: 8,
      padding: "6px 12px",
      fontSize: 13,
      color: "#121e71",
      cursor: "pointer",
      whiteSpace: "nowrap",
    },
    dropMenu: {
      position: "absolute",
      top: "calc(100% + 4px)",
      right: 0,
      background: "#fff",
      border: "1px solid #e2e8f0",
      borderRadius: 8,
      boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
      zIndex: 100,
      minWidth: 140,
      overflow: "hidden",
    },
    dropItem: {
      padding: "8px 14px",
      fontSize: 13,
      cursor: "pointer",
      color: "#121e71",
      transition: "background 0.15s",
    },
    dropItemActive: {
      background: "#eef0fd",
      color: "#5c6ce4",
      fontWeight: 500,
    },
  };